import { useState, useMemo } from 'react';

/** 單一優惠代碼（可改由 KV/CMS 或 API 提供） */
interface CouponItem {
  brand: string;
  code: string;
  title: string;
  keywords: string[];
}

const MOCK_COUPONS: CouponItem[] = [
  {
    brand: '麥當勞',
    code: 'XXXXX',
    title: '經典套餐優惠',
    keywords: ['麥當勞', '漢堡', '套餐', '速食'],
  },
  {
    brand: '麥當勞',
    code: 'YYYYY',
    title: '早餐組合',
    keywords: ['麥當勞', '早餐'],
  },
  {
    brand: '肯德基',
    code: '24XXX',
    title: '炸雞 $159 等優惠',
    keywords: ['肯德基', '炸雞', 'KFC'],
  },
  {
    brand: '必勝客',
    code: 'PIZZA50',
    title: '披薩折扣',
    keywords: ['必勝客', '披薩', 'pizza'],
  },
  {
    brand: '摩斯漢堡',
    code: 'MOSXXX',
    title: '米漢堡／紅茶優惠',
    keywords: ['摩斯', '漢堡'],
  },
];

/**
 * 速食優惠代碼快搜：輸入關鍵字查詢麥當勞、肯德基、必勝客等可用代碼
 */
export function FastFoodCouponTool() {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return MOCK_COUPONS;
    return MOCK_COUPONS.filter(
      item =>
        item.brand.toLowerCase().includes(q) ||
        item.title.toLowerCase().includes(q) ||
        item.keywords.some(k => k.toLowerCase().includes(q))
    );
  }, [query]);

  return (
    <>
      <div className="mb-6 rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
          關鍵字搜尋（例如：麥當勞、炸雞、披薩）
        </label>
        <input
          type="text"
          value={query}
          onChange={e => setQuery(e.target.value)}
          placeholder="輸入品牌或品項..."
          className="w-full rounded border border-gray-300 bg-white px-4 py-3 text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
          aria-label="搜尋優惠代碼"
        />
      </div>

      <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-start">
        <div className="flex-1 rounded-lg border border-gray-200 bg-gray-50 p-6 dark:border-gray-700 dark:bg-gray-800">
          <h2 className="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">
            目前可用優惠代碼（範例）
          </h2>
          {filtered.length === 0 ? (
            <p className="text-gray-500 dark:text-gray-400">沒有符合的結果</p>
          ) : (
            <ul className="space-y-3">
              {filtered.map((item, i) => (
                <li
                  key={`${item.brand}-${item.code}-${i}`}
                  className="flex flex-wrap items-center gap-2 rounded border border-gray-200 bg-white p-3 dark:border-gray-600 dark:bg-gray-700"
                >
                  <span className="font-medium text-gray-900 dark:text-gray-100">
                    {item.brand}
                  </span>
                  <code className="rounded bg-primary/10 px-2 py-0.5 font-mono text-sm text-primary">
                    {item.code}
                  </code>
                  <span className="text-sm text-gray-600 dark:text-gray-400">
                    {item.title}
                  </span>
                </li>
              ))}
            </ul>
          )}
          <p className="mt-3 text-xs text-gray-500 dark:text-gray-400">
            以上為示意資料。實際上線可改由後端定時抓取或維護，午餐時段（11:00～12:30）流量最高。
          </p>
        </div>
      </div>

      <section className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-lg font-semibold text-gray-900 dark:text-gray-100">
          使用說明
        </h2>
        <p className="leading-relaxed text-gray-600 dark:text-gray-400">
          輸入「麥當勞」「炸雞」「披薩」等關鍵字，快速查詢連鎖速食店目前可用的五碼優惠券或代碼。可結合
          Cloudflare Workers 定時抓取各家官網優惠頁並快取於
          KV，以提升訪問速度與回訪率。
        </p>
      </section>
    </>
  );
}
